import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BlockDirective, ElemDirective } from '@rt-tools/core';
import { PageHeaderComponent } from '@stair-craft/common/components';
import { IWoodMaterial, WOOD_MATERIALS } from '@stair-craft/common/util';

interface ICatalogStub {
    readonly slug: string;
    readonly label: string;
    readonly text: string;
    // Taken from the calculator's material table, so the catalog and the quote name one density
    readonly density: number;
}

function densityOf(slug: string): number {
    return WOOD_MATERIALS.find((material: IWoodMaterial) => material.id === slug)?.density ?? 0;
}

const BEM_BLOCK: string = 'sc-catalog-list-page';

@Component({
    selector: 'sc-catalog-list-page',
    templateUrl: './catalog-list-page.component.html',
    styleUrl: './catalog-list-page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // angular
        RouterLink,

        // rt-tools
        BlockDirective,
        ElemDirective,

        // components
        PageHeaderComponent,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export default class CatalogListPageComponent {
    protected readonly items: readonly ICatalogStub[] = [
        {
            slug: 'oak',
            label: $localize`:@@catalogSpeciesOak:Дуб`,
            text: $localize`:@@catalogCardOakText:Твёрдый и износостойкий — для ступеней, которые служат десятилетиями.`,
            density: densityOf('oak'),
        },
        {
            slug: 'pine',
            label: $localize`:@@catalogSpeciesPine:Сосна`,
            text: $localize`:@@catalogCardPineText:Лёгкая и недорогая — для тетивы, косоуров и дачных лестниц.`,
            density: densityOf('pine'),
        },
        {
            slug: 'beech',
            label: $localize`:@@catalogSpeciesBeech:Бук`,
            text: $localize`:@@catalogCardBeechText:Ровный рисунок, хорошо держит покрытие.`,
            density: densityOf('beech'),
        },
        {
            slug: 'ash',
            label: $localize`:@@catalogSpeciesAsh:Ясень`,
            text: $localize`:@@catalogCardAshText:Упругий и прочный, с выразительной текстурой.`,
            density: densityOf('ash'),
        },
    ];
}
